import { useEffect, useState } from 'react';
import { AbsenceReportApi } from '../../../api';
import { AbsenceReportApiResponse } from '../../../api/AbsenceReportApi';
import { ManagedProjectDto } from '../../../commonTypes/reports.types';
import { useContainer } from '../../useContainer';

type WeeklyTrendData = AbsenceReportApiResponse.GetWeeklyTrend['body'];

const EMPTY_DATA: WeeklyTrendData = {
    days: [],
    totalAbsent: 0,
    busiestDay: null,
    busiestDayCount: 0,
    busiestDayTie: false,
};

export interface IGetWeeklyTrendQuery {
    fromDate: string;
    toDate: string;
    projectId?: string;
    enabled?: boolean;
}

const useHttpGetWeeklyTrend = (query: IGetWeeklyTrendQuery) => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);
    const [data, setData] = useState<WeeklyTrendData>(EMPTY_DATA);
    const [managedProjects, setManagedProjects] = useState<ManagedProjectDto[] | undefined>(undefined);
    const [isReady, setIsReady] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (query.enabled === false) return;

        setIsReady(false);
        setIsError(false);
        const { exec, abort } = absenceReportApi.getWeeklyTrend({
            query: { fromDate: query.fromDate, toDate: query.toDate, projectId: query.projectId },
            onSuccess: res => {
                setData(res.body);
                setManagedProjects(res.body.managedProjects);
                setIsError(false);
            },
            onError: () => setIsError(true),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, [query.fromDate, query.toDate, query.projectId, query.enabled]);

    return { data, managedProjects, isReady, isError };
};

export default useHttpGetWeeklyTrend;
